import React from 'react';
import { InputNumber, Tooltip, Button, Popconfirm, message, Select } from 'antd';
import ModalDom from '../../components/Modal';
import { config, postFrom } from '../../axios';

const Option = Select.Option;

class ChooseGoods extends React.Component {
    constructor(props) {
        super();

        this.state = {
            loading: false,
            visible: false,
            furnitureList: [],
            goodsData: [],
        }

        this.counter = 0
       
    }

    componentDidMount() {
        this.props.onRef(this)
    }
    loadPack = (furnitureList) => {
        return new Promise((resolve, reject) => {
            this.monitor = { resolve, reject }
            if (!furnitureList || !furnitureList.length) {
                furnitureList = [this.getInitSingle()]
            } else {
                furnitureList = furnitureList.map(e => {
                    this.counter++
                    e.id = this.counter
                    return e
                })
            }
            this.setState({ visible: true, furnitureList })

            this.postGoodsList()
        })
        
    }


    getInitSingle = (val = {}) => { //初始化的单条数据
        this.counter++
        return {
            key: this.counter,
            name: '',
            amount: 1,
            unitPrice: '',
            ...val
        }
    }

    postGoodsList() {
        postFrom({ url: config.API_dictionary_findList, data: { groupName: '房间物品' } }).then(res => {
            this.setState({ goodsData: res });
        }).catch(err => {
            message.error(err.message || '获取房间物品失败');
        });
    }


    checkFormData() {
        let result = true
        this.state.furnitureList.forEach(e => {
            if (!e.name) { result = false; message.warning('请选择物品名称') }
            if (!e.amount) { result = false; message.warning('请输入数量') }
        })
        return result
    }

    handleMinus = (index) => {
        let { furnitureList } = this.state;
        furnitureList.splice(index, 1);
        this.setState({ furnitureList });
    }

    handlePlus = () => {
        let { furnitureList, goodsData } = this.state;
        const merge = { name: goodsData[furnitureList.length] ? goodsData[furnitureList.length].dicValue : '' }
        furnitureList.push(this.getInitSingle(merge));
        
        this.setState({ furnitureList });
    }

   handleChange = (type, index, val)  => {
       const { furnitureList } = this.state
       furnitureList[index][type] = val
       this.setState({ furnitureList })
   }

    handleOk = () => {
        if (!this.checkFormData()) return
        this.monitor.resolve(this.state.furnitureList)
        this.setState({  visible: false });
    }



    render() {
        let {
            loading,
            furnitureList,
            goodsData,
            visible
        } = this.state;
        return (
            <ModalDom
                title="房间物品编辑"
                visible={visible}
                loading={loading}
                onOk={this.handleOk}
                onCancel={() => {
                    this.setState({ visible: false,  });
                }}
            >
                <div className="custom">
                    <div className="tableBox">
                        <div className="tableTitle">
                            <div style={{ flex: 1 }} className="xinxin xinxinColor">物品名称</div>
                            <div style={{ flex: 1 }} className="xinxin xinxinColor">数量</div>
                            <div style={{ flex: 1 }}>物品单价（元）</div>
                            <div style={{ flex: '0 0 100px' }}>操作</div>
                        </div>
                        <div className="tableBody">
                            {
                                furnitureList.map((item, index) => {
                                    return <div className="tableBodyRow" key={item.key}>
                                        <div style={{ flex: 1, alignItems: 'center' }}>
                                        
                                            <Select
                                                style={{width: '100%'}}
                                                showSearch
                                                placeholder="请选择"
                                                optionFilterProp={'children'}
                                                value={item.name}
                                                onChange={(e) => this.handleChange('name', index, e) }
                                            >
                                                {goodsData.map((item, index) => <Option value={item.dicValue} key={index}>{item.dicValue}</Option>)}
                                            </Select>
                                            
                                        </div>
                                        <div style={{ flex: 1 }}>
                                            <InputNumber
                                                min={1}
                                                value={item.amount}
                                                onChange={(e) => this.handleChange('amount', index, e) }
                                                className="XADSD-1"
                                            />
                                        </div>
                                        <div style={{ flex: 1 }}>
                                            <InputNumber
                                                min={0}
                                                value={item.unitPrice}
                                                onChange={(e) => this.handleChange('unitPrice', index, e) }
                                                style={{ paddingRight: '25px' }}
                                                className="money-right"
                                            />
                                        </div>
                                        <div style={{ flex: '0 0 100px' }}>
                                            <Popconfirm
                                                placement="topRight"
                                                title={'此删除操作不可恢复，确定删除吗？'}
                                                onConfirm={() => {
                                                    this.handleMinus(index)
                                                }}
                                                okText="删除"
                                                cancelText="取消"
                                            >
                                                <span className="showClickDetail">删除</span>
                                            </Popconfirm>
                                        </div>
                                    </div>
                                })
                            }
                            <div className="tableBodyRow" style={{ justifyContent: 'center', alignItems: 'center', height: '40px' }}>
                                <Tooltip placement="bottomLeft" title={"添加一行物品输入框"}>
                                    <Button onClick={this.handlePlus} style={{ width: '24px', height: '24px', textAlign: 'center', lineHeight: '16px', fontSize: '14px' }} shape="circle" icon="plus" />
                                </Tooltip>
                            </div>
                        </div>
                    </div>
                </div>
                <style>
                    {`
                        .XADSD-1 .ant-input-number-input{
                            text-align: center;
                        }
                    `}
                </style>
            </ModalDom>
        )
    }
}

export default ChooseGoods;


// WEBPACK FOOTER //
// ./src/containers/LeaseSigning/ChooseGoods.js